import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseButton from '@/components/common/BaseButton.vue'

type BigButtonType = 'primary' | 'secondary'

interface Props {
  text?: string
  type?: BigButtonType
  isDisabled?: boolean
  isLoading?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BigButton',
  props: {
    text: null,
    type: { default: 'primary' },
    isDisabled: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseButton, {
    class: _normalizeClass(['big-button', `big-button--${__props.type}`, { 'big-button--disabled': __props.isDisabled }]),
    text: __props.text,
    "is-disabled": __props.isDisabled,
    "is-loading": __props.isLoading
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "text", "is-disabled", "is-loading"]))
}
}

})